import { memo, useCallback } from 'react';
import { Box, Button, Grid } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { WhiteCard } from 'components/styles_components/card';
import { CardTitleTypography } from 'components/styles_components/typography';
import Role from 'components/role';

const ListItem = ({ space, onAccept, onReject, disabled }) => {
  const handleAccept = useCallback(() => {
    onAccept(space);
  }, [onAccept, space]);

  const handleReject = useCallback(() => {
    onReject(space);
  }, [onReject, space]);

  return (
    <WhiteCard>
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, sm: 7 }}>
          <CardTitleTypography>{space.name}</CardTitleTypography>
          <Role role={space.role} />
        </Grid>
        <Grid size={{ xs: 12, sm: 5 }}>
          <Box display="flex" gap={1} justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}>
            <Button variant="contained" size="small" disabled={disabled} onClick={handleAccept}>
              <FormattedMessage id="button.accept" />
            </Button>
            <Button variant="outlined" size="small" disabled={disabled} onClick={handleReject}>
              <FormattedMessage id="button.reject" />
            </Button>
          </Box>
        </Grid>
      </Grid>
    </WhiteCard>
  );
};

export default memo(ListItem);
